<template>
    <ReportPeriodPicker v-if="field.type === 'period'" v-model="filters[field.key]" allow-clear />

    <span v-else-if="field.type === 'range'" class="ant-calendar-picker range-field">
        <span class="ant-calendar-picker-input ant-input">
            <input
                :value="filters[field.key][0]"
                class="ant-calendar-range-picker-input"
                :placeholder="labelled ? 'De' : `${field.label} de`"
                inputmode="decimal"
                @input="setRange(0, $event)"
                @keydown.enter="$emit('enter')"
            />
            <span class="ant-calendar-range-picker-separator"> ~ </span>
            <input
                :value="filters[field.key][1]"
                class="ant-calendar-range-picker-input"
                :placeholder="labelled ? 'Até' : 'até'"
                inputmode="decimal"
                @input="setRange(1, $event)"
                @keydown.enter="$emit('enter')"
            />
            <a-icon
                v-if="filters[field.key][0] || filters[field.key][1]"
                type="close-circle"
                theme="filled"
                class="ant-calendar-picker-clear"
                @click.stop="clearRange"
            />
        </span>
    </span>

    <div v-else-if="field.type === 'checkbox'" class="checkbox-field">
        <a-checkbox v-model="filters[field.key]">{{ labelled ? "Sim" : field.label }}</a-checkbox>
    </div>

    <a-select
        v-else-if="field.type === 'select'"
        v-model="filters[field.key]"
        :mode="field.multiple ? 'multiple' : 'default'"
        :class="{ 'fixed-height-select': field.multiple }"
        style="width: 100%"
        allow-clear
        show-search
        :placeholder="labelled ? 'Todos' : field.label"
        :max-tag-count="1"
        :filter-option="filterOption"
        :dropdown-style="{ minWidth: field.dropdownWidth || '200px' }"
    >
        <a-select-option v-for="option in field.options || []" :key="option.value" :value="option.value">
            {{ option.label }}
        </a-select-option>
    </a-select>

    <a-input
        v-else
        :value="filters[field.key]"
        :placeholder="labelled ? '' : field.label"
        allowClear
        @input="setText($event)"
        @pressEnter="$emit('enter')"
    />
</template>

<script>
import reportFormat from "@/pages/reports/tabs/report-format.mixin";
import ReportPeriodPicker from "@/pages/reports/components/ReportPeriodPicker.vue";

export default {
    name: "FilterField",
    components: { ReportPeriodPicker },
    mixins: [reportFormat],
    props: {
        field: { type: Object, required: true },
        filters: { type: Object, required: true },
        labelled: { type: Boolean, default: false },
    },
    methods: {
        setText(event) {
            const value = this.field.digits ? event.target.value.replace(/\D/g, "") : event.target.value;
            this.filters[this.field.key] = value;
            event.target.value = value;
        },
        clearRange() {
            this.filters[this.field.key] = ["", ""];
        },
        setRange(index, event) {
            const [integer, ...decimals] = event.target.value.replace(/[^\d,]/g, "").split(",");
            const value = decimals.length ? `${integer},${decimals.join("").slice(0, 2)}` : integer;
            const range = [...this.filters[this.field.key]];
            range[index] = value;
            this.filters[this.field.key] = range;
            event.target.value = value;
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-field {
    height: 32px;
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.range-field {
    width: 100%;

    .ant-calendar-range-picker-input {
        cursor: text;
    }
}
</style>
